import { BetaPage } from '@features/auth/components/BetaPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/beta')({ component: BetaPage });
